<script setup lang="ts">
import { MediaImageFragment } from '~/api/graphql/generated'

interface RoomIconItemProps {
  icon?: MediaImageFragment | null
  variant?: string
  value?: string
}

withDefaults(defineProps<RoomIconItemProps>(), {
  variant: '',
  value: '',
  icon: null,
})
</script>

<template>
  <div v-animate="{ animation: 'vertical-reveal' }" class="room-icon-item">
    <div v-if="icon" class="icon-wrapper">
      <Image class="icon-image" type="teaser" :small="icon" :large="icon" :entity="icon" />
    </div>

    <div class="icon-text">
      <div class="icon-variant text-xsmall" v-text="variant" />
      <div class="icon-value text-xsmall" v-html="value" />
    </div>
  </div>
</template>

<style scoped lang="scss">
.room-icon-item {
  display: flex;
  flex-direction: column;

  @include fluid(gap, 9px, 12px);
  @include breakpoint(ts) {
    flex-direction: row;
  }
}

.icon-wrapper {
  flex-shrink: 0;
  width: 24px;
  height: 24px;

  .icon-image {
    width: 100%;
    height: 100%;

    :deep(img) {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
}

.icon-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0; // Allow text to wrap
}

.icon-value {
  color: var(--c-text-strong);
  font-weight: 600;
  word-wrap: break-word;

  :deep(sub),
  :deep(sup) {
    font-size: 0.75em;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }

  :deep(sub) {
    bottom: -0.25em;
  }

  :deep(sup) {
    top: -0.5em;
  }

  :deep(*:last-child) {
    margin-bottom: 0;
  }
}

// Mobile-first approach - no additional mobile styles needed
// as the default styles already work for mobile
</style>
